var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "addclient"
  }, [_c('div', {
    staticClass: "card-block"
  }, [(_vm.phoneNumbers.length > 0) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table",
    attrs: {
      "data-testid": "registration-phone-list"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.phoneNumbers), function(phoneNum) {
    return [_c('tr', [_c('td', {
      staticClass: "align-middle"
    }, [_vm._v("\n                " + _vm._s(phoneNum.number) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(phoneNum.default === true ? 'výchozí' : '') + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(phoneNum.note) + "\n              ")])])]
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [(!_vm.waitForData) ? _c('form', {
    attrs: {
      "data-testid": "registration-phone-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.selectedPhoneNumberPrefix))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPhoneNumber),
      expression: "selectedPhoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "telefonní číslo",
      "id": "phoneNumber",
      "data-testid": "registration-phone-number"
    },
    domProps: {
      "value": (_vm.selectedPhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedPhoneNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                        Výchozí: \n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber.default),
      expression: "phoneNumber.default"
    }],
    attrs: {
      "type": "checkbox",
      "aria-label": "Checkbox for following text input",
      "data-testid": "registration-phone-default"
    },
    domProps: {
      "checked": Array.isArray(_vm.phoneNumber.default) ? _vm._i(_vm.phoneNumber.default, null) > -1 : (_vm.phoneNumber.default)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.phoneNumber.default,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.phoneNumber.default = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.phoneNumber.default = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.phoneNumber.default = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber.note),
      expression: "phoneNumber.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "phoneNumberf",
      "data-testid": "registration-phone-note",
      "placeholder": "poznámka"
    },
    domProps: {
      "value": (_vm.phoneNumber.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber.note = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.phoneNumberPending === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "data-testid": "registration-phone-add"
    }
  }, [_vm._v("Přidat telefon")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])]), _vm._v(" "), (_vm.phoneNumberError.number) ? _c('small', {
    staticClass: "form-text text-danger",
    attrs: {
      "id": "numberError",
      "data-testid": "registration-phone-error"
    }
  }, [_vm._v(_vm._s(_vm.phoneNumberError.number.message))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group col-md-12 text-center"
  }, [(_vm.phoneNumberPending || _vm.phoneNumbersPending) ? _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Čekám")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-testid": "registration-phone-next"
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Další krok "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])]), _vm._v(" "), (_vm.waitForData) ? _c('div', {
    staticClass: "row justify-content-around"
  }, [_vm._m(1)]) : _vm._e()])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Telefonní číslo")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af48fbcc","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Registration/components/RegistrationClientPhone.vue
// module id = 471
// module chunks = 0